import { Component, ElementRef, ViewChild, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { AssistantService } from '../_services/assistant.service';

//The AI staff assistant's button and chat panel - PROTOTYPE. Shown on every page once signed in,
//when the Dashboard has an assistant relay to talk to (environment.aiAssistantUrl). The panel is a
//plain fixed box rather than a PrimeNG sidebar or dialog, so it never lays a mask over the page.
@Component({
  selector: 'app-assistant',
  templateUrl: './assistant.component.html',
  styleUrls: ['./assistant.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AssistantComponent implements AfterViewChecked {

  @ViewChild('scroller') scroller: ElementRef<HTMLElement>;

  open: boolean = false;
  question: string = '';

  readonly suggestions: string[] = [
    'How many bookings do we have this weekend?',
    'Which parties next week have allergies?',
    'What did we take last month, by package?',
    'Who has money outstanding for bookings this week?',
    'Why isn\'t a package showing on a day?'
  ];

  //Scrolls to the newest line only when one has been added, so reading back up is not fought.
  private shownEntries = 0;

  //Built each time a venue is entered (app.component only shows it inside a venue), so a
  //conversation from another venue is cleared here.
  constructor(public assistant: AssistantService) {
    this.assistant.checkVenue();
  }

  ngAfterViewChecked(): void {
    if (this.scroller != null && this.assistant.entries.length != this.shownEntries) {
      this.shownEntries = this.assistant.entries.length;
      const box = this.scroller.nativeElement;
      box.scrollTop = box.scrollHeight;
    }
  }

  send(text?: string): void {
    const question = (text ?? this.question).trim();

    if (question == '' || this.assistant.working) {
      return;
    }

    this.question = '';
    this.assistant.ask(question);
  }

  //Enter sends; Shift+Enter starts a new line.
  onKeydown(event: KeyboardEvent): void {
    if (event.key == 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.send();
    }
  }
}
